<template>
  <div>
    <div class="card-form">
      <div class="text-center mb-6">
        You choose to donate
        <b
          >{{ donation.currency.symbol }}
          <span v-if="donation.tip != 1">{{ donation.amount }}</span>
          <span v-else>{{ (donation.amount * 1.05).toFixed(1) }}</span></b
        >
        by Credit Card
        <span v-if="donation.monthly == 1">monthly</span>
        <span v-else>one time</span>
        &nbsp;
        <a class="small text-muted" href="#" @click.prevent="changeMode"
          >Change</a
        >
      </div>

      <div class="card-list mb-6" v-if="showCard">
        <div class="card-item" v-bind:class="{ '-active': isCardFlipped }">
          <div class="card-item__side -front">
            <div
              class="card-item__focus"
              v-bind:class="{ '-active': focusElementStyle }"
              v-bind:style="focusElementStyle"
              ref="focusElement"
            ></div>
            <div class="card-item__cover">
              <img
                v-bind:src="
                  require('../assets/img/' + currentCardBackground + '.jpeg')
                "
                class="card-item__bg"
              />
            </div>

            <div class="card-item__wrapper">
              <div class="card-item__top">
                <img src="../assets/img/chip.png" class="card-item__chip" />
                <div class="card-item__type">
                  <transition name="slide-fade-up">
                    <img
                      v-bind:src="
                        require('../assets/img/' + getCardType + '.png')
                      "
                      v-if="getCardType"
                      v-bind:key="getCardType"
                      alt
                      class="card-item__typeImg"
                    />
                  </transition>
                </div>
              </div>
              <label
                for="cardNumber"
                class="card-item__number"
                ref="cardNumber"
              >
                <template v-if="getCardType === 'amex'">
                  <span v-for="(n, $index) in amexCardMask" :key="$index">
                    <transition name="slide-fade-up">
                      <div
                        class="card-item__numberItem"
                        v-if="
                          $index > 4 &&
                          $index < 14 &&
                          donation.cardNumber.length > $index &&
                          n.trim() !== ''
                        "
                      >
                        *
                      </div>
                      <div
                        class="card-item__numberItem"
                        :class="{ '-active': n.trim() === '' }"
                        :key="$index"
                        v-else-if="donation.cardNumber.length > $index"
                      >
                        {{ donation.cardNumber[$index] }}
                      </div>
                      <div
                        class="card-item__numberItem"
                        :class="{ '-active': n.trim() === '' }"
                        v-else
                        :key="$index + 1"
                      >
                        {{ n }}
                      </div>
                    </transition>
                  </span>
                </template>

                <template v-else>
                  <span v-for="(n, $index) in otherCardMask" :key="$index">
                    <transition name="slide-fade-up">
                      <div
                        class="card-item__numberItem"
                        v-if="
                          $index > 4 &&
                          $index < 15 &&
                          donation.cardNumber.length > $index &&
                          n.trim() !== ''
                        "
                      >
                        *
                      </div>
                      <div
                        class="card-item__numberItem"
                        :class="{ '-active': n.trim() === '' }"
                        :key="$index"
                        v-else-if="donation.cardNumber.length > $index"
                      >
                        {{ donation.cardNumber[$index] }}
                      </div>
                      <div
                        class="card-item__numberItem"
                        :class="{ '-active': n.trim() === '' }"
                        v-else
                        :key="$index + 1"
                      >
                        {{ n }}
                      </div>
                    </transition>
                  </span>
                </template>
              </label>
              <div class="card-item__content">
                <label for="cardName" class="card-item__info" ref="cardName">
                  <div class="card-item__holder">Card Holder</div>
                  <transition name="slide-fade-up">
                    <div
                      class="card-item__name"
                      v-if="donation.cardName.length"
                      key="1"
                    >
                      <transition-group name="slide-fade-right">
                        <span
                          class="card-item__nameItem"
                          v-for="(n, $index) in donation.cardName.replace(
                            /\s\s+/g,
                            ' '
                          )"
                          v-if="$index === $index"
                          v-bind:key="$index + 1"
                          >{{ n }}</span
                        >
                      </transition-group>
                    </div>
                    <div class="card-item__name" v-else key="2">Full Name</div>
                  </transition>
                </label>
                <div class="card-item__date" ref="cardDate">
                  <label for="donation.cardMonth" class="card-item__dateTitle"
                    >Expires</label
                  >
                  <label for="donation.cardMonth" class="card-item__dateItem">
                    <transition name="slide-fade-up">
                      <span
                        v-if="donation.cardMonth"
                        v-bind:key="donation.cardMonth"
                        >{{ donation.cardMonth }}</span
                      >
                      <span v-else key="2">MM</span>
                    </transition>
                  </label>
                  /
                  <label for="donation.cardYear" class="card-item__dateItem">
                    <transition name="slide-fade-up">
                      <span
                        v-if="donation.cardYear"
                        v-bind:key="donation.cardYear"
                        >{{ String(donation.cardYear).slice(2, 4) }}</span
                      >
                      <span v-else key="2">YY</span>
                    </transition>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="card-item__side -back">
            <div class="card-item__cover">
              <img
                v-bind:src="
                  require('../assets/img/' + currentCardBackground + '.jpeg')
                "
                class="card-item__bg"
              />
            </div>
            <div class="card-item__band"></div>
            <div class="card-item__cvv">
              <div class="card-item__cvvTitle">CVV</div>
              <div class="card-item__cvvBand">
                <span v-for="(n, $index) in donation.cardCvv" :key="$index"
                  >*</span
                >
              </div>
              <div class="card-item__type">
                <img
                  v-bind:src="require('../assets/img/' + getCardType + '.png')"
                  v-if="getCardType"
                  class="card-item__typeImg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="vertical-input-group">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              aria-describedby="helpId"
              placeholder="Full name"
              v-model="donation.cardName"
              v-on:focus="focusInput"
              v-on:blur="blurInput"
              data-ref="cardName"
              autocomplete="off"
              id="cardName"
            />
          </div>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="donation.cardEmail"
              aria-describedby="helpId"
              placeholder="Your email"
            />
          </div>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="donation.address"
              aria-describedby="helpId"
              placeholder="Your Address"
            />
          </div>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="donation.city"
              aria-describedby="helpId"
              placeholder="Your City"
            />
            <input
              type="text"
              class="form-control"
              v-model="donation.zip"
              aria-describedby="helpId"
              :placeholder="$store.state.country == 'us' ? 'ZIP' : 'Postal'"
            />
          </div>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="donation.state"
              aria-describedby="helpId"
              :placeholder="
                $store.state.country == 'us' ? 'Your State' : 'Your Province'
              "
            />
            <select
              class="form-control"
              id="donation.country_id"
              v-model="donation.country_id"
              v-on:focus="focusInput"
              v-on:blur="blurInput"
              data-ref="coutryId"
              placeholder="Your country"
            >
              <option value disabled selected>Select your country</option>
              <option
                v-for="country in countries"
                v-bind:value="country.id"
                v-bind:key="country.id"
              >
                {{ country.name }}
              </option>
            </select>
          </div>
          <div class="input-group">
            <input
              type="text"
              id="cardNumber"
              class="form-control"
              v-mask="generateCardNumberMask"
              v-model="donation.cardNumber"
              v-on:focus="focusInput"
              v-on:blur="blurInput"
              data-ref="cardNumber"
              autocomplete="off"
              placeholder="Card number"
            />
          </div>
          <div class="input-group">
            <select
              class="form-control"
              id="donation.cardMonth"
              v-model="donation.cardMonth"
              v-on:focus="focusInput"
              v-on:blur="blurInput"
              data-ref="cardDate"
            >
              <option value disabled selected>Month</option>
              <option
                v-bind:value="n < 10 ? '0' + n : n"
                v-for="n in 12"
                v-bind:disabled="n < minCardMonth"
                v-bind:key="n"
              >
                {{ n < 10 ? "0" + n : n }}
              </option>
            </select>
            <select
              class="form-control"
              id="donation.cardYear"
              v-model="donation.cardYear"
              v-on:focus="focusInput"
              v-on:blur="blurInput"
              data-ref="cardDate"
            >
              <option value disabled selected>Year</option>
              <option
                v-bind:value="$index + minCardYear"
                v-for="(n, $index) in 12"
                v-bind:key="n"
              >
                {{ $index + minCardYear }}
              </option>
            </select>
            <!-- <label for="cardCvv" class="card-input__label">CVV</label> -->
            <input
              type="text"
              class="form-control"
              id="cardCvv"
              v-mask="'####'"
              maxlength="4"
              v-model="donation.cardCvv"
              v-on:focus="flipCard(true)"
              v-on:blur="flipCard(false)"
              autocomplete="off"
              placeholder="CVV"
            />
          </div>
        </div>
        <div class="alert alert-danger" role="alert" v-if="showError">
          {{ error }}
        </div>
        <button
          @click.prevent="processCc"
          :disabled="processing || !valid"
          :class="[processing ? 'disabled' : '']"
          class="btn btn-success btn-block mt-5"
        >
          <div v-if="!processing">
            <i class="fad fa-shield-check"></i> Secure Payment
          </div>
          <div v-else>
            <span class="spinner-border text-primary mb-1" role="status">
              <span class="sr-only">Processing...</span>
            </span>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);
export default {
  props: {
    organization: {},
    donation: {},
    showCard: { default: true },
  },
  data() {
    return {
      processing: false,
      countries: [],
      error: "",
      showError: false,
      currentCardBackground: Math.floor(Math.random() * 25 + 1), // just for fun :D
      minCardYear: new Date().getFullYear(),
      amexCardMask: "#### ###### #####",
      otherCardMask: "#### #### #### ####",
      cardNumberTemp: "",
      isCardFlipped: false,
      focusElementStyle: null,
      isInputFocused: false,
    };
  },
  mounted() {
    let self = this;
    this.cardNumberTemp = this.otherCardMask;
    document.getElementById("cardName").focus();
    document.getElementById("payment-card").scrollIntoView();
    this.axios
      .get(window.API_URL + "countries")
      .then(function (response) {
        self.countries = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  computed: {
    getCardType() {
      let number = this.donation.cardNumber;
      let re = new RegExp("^4");
      if (number.match(re) != null) return "visa";

      re = new RegExp("^(34|37)");
      if (number.match(re) != null) return "amex";

      re = new RegExp("^5[1-5]");
      if (number.match(re) != null) return "mastercard";

      re = new RegExp("^6011");
      if (number.match(re) != null) return "discover";

      re = new RegExp("^9792");
      if (number.match(re) != null) return "troy";

      return "visa"; // default type
    },
    valid() {
      if (
        this.donation.cardName != "" &&
        this.donation.cardName.trim().indexOf(" ") != -1 &&
        this.donation.cardEmail != "" &&
        this.donation.address != "" &&
        this.donation.city != "" &&
        this.donation.zip != "" &&
        this.donation.state != "" &&
        this.donation.country_id != "" &&
        String(this.donation.cardEmail)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) &&
        this.donation.cardNumber != "" &&
        this.donation.cardMonth != "" &&
        this.donation.cardYear != "" &&
        this.donation.cardCvv != ""
      ) {
        return true;
      } else {
        return false;
      }
    },
    generateCardNumberMask() {
      return this.getCardType === "amex"
        ? this.amexCardMask
        : this.otherCardMask;
    },
    minCardMonth() {
      if (this.donation.cardYear === this.minCardYear)
        return new Date().getMonth() + 1;
      return 1;
    },
  },
  watch: {
    cardYear() {
      if (this.donation.cardMonth < this.donation.minCardMonth) {
        this.donation.cardMonth = "";
      }
    },
  },
  methods: {
    changeMode() {
      this.donation.creditCard = false;
      this.$nextTick(function () {
        document.getElementById("payment-card").scrollIntoView();
      });
    },
    flipCard(status) {
      this.isCardFlipped = status;
    },
    _djb2Hash(str) {
      let hash = 5381;
      for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5) + hash) ^ str.charCodeAt(i);
        hash = hash >>> 0;
      }
      return hash.toString(16);
    },
    async _hashFingerprint(str) {
      try {
        const buf = await crypto.subtle.digest(
          "SHA-256",
          new TextEncoder().encode(str)
        );
        return Array.from(new Uint8Array(buf))
          .map((b) => b.toString(16).padStart(2, "0"))
          .join("");
      } catch (e) {
        return this._djb2Hash(str);
      }
    },
    async processCc() {
      let self = this;
      self.processing = true;
      await this.$recaptchaLoaded();
      this.donation.token = await this.$recaptcha("payment");
      this.donation.amount =
        this.donation.tip == 1
          ? this.donation.amount * 1.05
          : this.donation.amount;
      self.error = "";
      self.showError = false;
      this.donation.organization_id = this.organization.id;
      this.donation.organization_name = this.organization.name;
      this.donation.code =
        this.organization[this.$store.state.country + "_code"];
      this.donation.country = this.$store.state.country;

      // Collect device/browser signals — failures leave fields as empty strings
      this.donation.screen_resolution = "";
      this.donation.browser_fingerprint = "";
      this.donation.device_fingerprint = "";
      try {
        this.donation.screen_resolution =
          window.screen.width + "x" + window.screen.height;
        const browserParts = [
          navigator.userAgent,
          navigator.language,
          String(navigator.hardwareConcurrency),
          String(
            navigator.deviceMemory !== undefined ? navigator.deviceMemory : ""
          ),
          screen.width + "x" + screen.height + "x" + screen.colorDepth,
          Intl.DateTimeFormat().resolvedOptions().timeZone,
          navigator.platform,
        ];
        const deviceParts = browserParts.concat([
          String(navigator.maxTouchPoints),
          String(window.devicePixelRatio),
          String(typeof sessionStorage !== "undefined"),
          String(typeof indexedDB !== "undefined"),
        ]);
        this.donation.browser_fingerprint = await self._hashFingerprint(
          browserParts.join("|")
        );
        this.donation.device_fingerprint = await self._hashFingerprint(
          deviceParts.join("|")
        );
      } catch (e) {
        // fields remain empty strings — payment proceeds regardless
      }

      this.axios
        .post(window.API_URL + "process_payment", this.donation)
        .then(function (response) {
          if (response.data.status && response.data.status == "success") {
            self.donation.finished = true;
            self.donation.id = response.data.donation.id;
          } else {
            if (response.data.message) {
              self.error = response.data.message;
            } else {
              self.error = response.data;
            }
            self.showError = true;
          }
          self.processing = false;
        })
        .catch(function (error) {
          self.processing = false;
        });
    },
    focusInput(e) {
      if (this.showCard) {
        this.isInputFocused = true;
        let targetRef = e.target.dataset.ref;
        let target = this.$refs[targetRef];
        this.focusElementStyle = {
          width: `${target.offsetWidth}px`,
          height: `${target.offsetHeight}px`,
          transform: `translateX(${target.offsetLeft}px) translateY(${target.offsetTop}px)`,
        };
      }
    },
    blurInput() {
      let vm = this;
      setTimeout(() => {
        if (!vm.isInputFocused) {
          vm.focusElementStyle = null;
        }
      }, 300);
      vm.isInputFocused = false;
    },
  },
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Source+Code+Pro:400,500,600,700|Source+Sans+Pro:400,600,700&display=swap");
* {
  box-sizing: border-box;
  &:focus {
    outline: none;
  }
}
.card-form {
  max-width: 570px;
  margin: auto;
  width: 100%;

  @media screen and (max-width: 576px) {
    margin: 0 auto;
  }

  &__inner {
    border: 1px solid #eee;
    border-radius: 10px;
    padding: 35px;
    padding-top: 180px;

    @media screen and (max-width: 480px) {
      padding: 25px;
      padding-top: 165px;
    }
    @media screen and (max-width: 360px) {
      padding: 15px;
      padding-top: 165px;
    }
  }

  &__row {
    display: flex;
    align-items: flex-start;
    @media screen and (max-width: 480px) {
      flex-wrap: wrap;
    }
  }

  &__col {
    flex: auto;
    margin-right: 35px;

    &:last-child {
      margin-right: 0;
    }

    @media screen and (max-width: 480px) {
      margin-right: 0;
      flex: unset;
      width: 100%;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &.-cvv {
      max-width: 150px;
      @media screen and (max-width: 480px) {
        max-width: initial;
      }
    }
  }

  &__group {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;

    .card-input__input {
      flex: 1;
      margin-right: 15px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__button {
    width: 100%;
    height: 55px;
    background: #2364d2;
    border: none;
    border-radius: 5px;
    font-size: 22px;
    font-weight: 500;
    font-family: "Source Sans Pro", sans-serif;
    box-shadow: 3px 10px 20px 0px rgba(35, 100, 210, 0.3);
    color: #fff;
    margin-top: 20px;
    cursor: pointer;

    @media screen and (max-width: 480px) {
      margin-top: 10px;
    }
  }
}

.card-item {
  max-width: 430px;
  height: 270px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 2;
  width: 100%;

  @media screen and (max-width: 480px) {
    max-width: 310px;
    height: 220px;
    width: 100%;
  }

  @media screen and (max-width: 360px) {
    height: 180px;
  }

  &.-active {
    .card-item__side {
      &.-front {
        transform: perspective(1000px) rotateY(180deg) rotateX(0deg)
          rotateZ(0deg);
      }
      &.-back {
        transform: perspective(1000px) rotateY(0) rotateX(0deg) rotateZ(0deg);
        // box-shadow: 0 20px 50px 0 rgba(81, 88, 206, 0.65);
      }
    }
  }

  &__focus {
    position: absolute;
    z-index: 3;
    border-radius: 5px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition: all 0.35s cubic-bezier(0.71, 0.03, 0.56, 0.85);
    opacity: 0;
    pointer-events: none;
    overflow: hidden;
    border: 2px solid rgba(255, 255, 255, 0.65);

    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      background: rgb(8, 20, 47);
      height: 100%;
      border-radius: 5px;
      filter: blur(25px);
      opacity: 0.5;
    }

    &.-active {
      opacity: 1;
    }
  }

  &__side {
    border-radius: 15px;
    overflow: hidden;
    // box-shadow: 3px 13px 30px 0px rgba(11, 19, 41, 0.5);
    box-shadow: 0 10px 10px 0 rgba(14, 42, 90, 0.25);
    transform: perspective(2000px) rotateY(0deg) rotateX(0deg) rotate(0deg);
    transform-style: preserve-3d;
    transition: all 0.8s cubic-bezier(0.71, 0.03, 0.56, 0.85);
    backface-visibility: hidden;
    height: 100%;
    margin-bottom: 40px;

    &.-back {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      transform: perspective(2000px) rotateY(-180deg) rotateX(0deg) rotate(0deg);
      z-index: 2;
      padding: 0;
      // background-color: #2364d2;
      // background-image: linear-gradient(
      //   43deg,
      //   #4158d0 0%,
      //   #8555c7 46%,
      //   #2364d2 100%
      // );
      height: 100%;

      .card-item__cover {
        transform: rotateY(-180deg);
      }
    }
  }
  &__bg {
    max-width: 100%;
    display: block;
    max-height: 100%;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  &__cover {
    height: 100%;
    background-color: #1c1d27;
    position: absolute;
    height: 100%;
    background-color: #1c1d27;
    left: 0;
    top: 0;
    width: 100%;
    border-radius: 15px;
    overflow: hidden;
    &:after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(6, 2, 29, 0.45);
    }
  }

  &__top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 40px;
    padding: 0 10px;

    @media screen and (max-width: 480px) {
      margin-bottom: 25px;
    }
    @media screen and (max-width: 360px) {
      margin-bottom: 15px;
    }
  }

  &__chip {
    width: 60px;
    @media screen and (max-width: 480px) {
      width: 50px;
    }
    @media screen and (max-width: 360px) {
      width: 40px;
    }
  }

  &__type {
    height: 45px;
    position: relative;
    display: flex;
    justify-content: flex-end;
    max-width: 100px;
    margin-left: auto;
    width: 100%;

    @media screen and (max-width: 480px) {
      height: 40px;
      max-width: 90px;
    }
    @media screen and (max-width: 360px) {
      height: 30px;
    }
  }

  &__typeImg {
    max-width: 100%;
    object-fit: contain;
    max-height: 100%;
    object-position: top right;
  }

  &__info {
    color: #fff;
    width: 100%;
    max-width: calc(100% - 85px);
    padding: 10px 15px;
    font-weight: 500;
    display: block;

    cursor: pointer;

    @media screen and (max-width: 480px) {
      padding: 10px;
    }
  }

  &__holder {
    opacity: 0.7;
    font-size: 13px;
    margin-bottom: 6px;
    @media screen and (max-width: 480px) {
      font-size: 12px;
      margin-bottom: 5px;
    }
  }

  &__wrapper {
    font-family: "Source Code Pro", monospace;
    padding: 25px 15px;
    position: relative;
    z-index: 4;
    height: 100%;
    text-shadow: 7px 6px 10px rgba(14, 42, 90, 0.8);
    user-select: none;
    @media screen and (max-width: 480px) {
      padding: 20px 10px;
    }
  }

  &__name {
    font-size: 18px;
    line-height: 1;
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: uppercase;
    @media screen and (max-width: 480px) {
      font-size: 16px;
    }
  }
  &__nameItem {
    display: inline-block;
    min-width: 8px;
    position: relative;
  }

  &__number {
    font-weight: 500;
    line-height: 1;
    color: #fff;
    font-size: 27px;
    margin-bottom: 35px;
    display: inline-block;
    padding: 10px 15px;
    cursor: pointer;

    @media screen and (max-width: 480px) {
      font-size: 21px;
      margin-bottom: 15px;
      padding: 10px 10px;
    }

    @media screen and (max-width: 360px) {
      font-size: 19px;
      margin-bottom: 10px;
      padding: 10px 10px;
    }
  }

  &__numberItem {
    width: 16px;
    display: inline-block;
    &.-active {
      width: 30px;
    }

    @media screen and (max-width: 480px) {
      width: 13px;

      &.-active {
        width: 16px;
      }
    }

    @media screen and (max-width: 360px) {
      width: 12px;

      &.-active {
        width: 8px;
      }
    }
  }

  &__content {
    color: #fff;
    display: flex;
    align-items: flex-start;
  }

  &__date {
    flex-wrap: wrap;
    font-size: 18px;
    margin-left: auto;
    padding: 10px;
    display: inline-flex;
    width: 80px;
    white-space: nowrap;
    flex-shrink: 0;
    cursor: pointer;

    @media screen and (max-width: 480px) {
      font-size: 16px;
    }
  }

  &__dateItem {
    position: relative;
    span {
      width: 22px;
      display: inline-block;
    }
  }

  &__dateTitle {
    opacity: 0.7;
    font-size: 13px;
    padding-bottom: 6px;
    width: 100%;
    margin: 0;

    @media screen and (max-width: 480px) {
      font-size: 12px;
      padding-bottom: 5px;
    }
  }
  &__band {
    background: rgba(0, 0, 19, 0.8);
    width: 100%;
    height: 50px;
    margin-top: 30px;
    position: relative;
    z-index: 2;
    @media screen and (max-width: 480px) {
      margin-top: 20px;
    }
    @media screen and (max-width: 360px) {
      height: 40px;
      margin-top: 10px;
    }
  }

  &__cvv {
    text-align: right;
    position: relative;
    z-index: 2;
    padding: 15px;
    .card-item__type {
      opacity: 0.7;
    }

    @media screen and (max-width: 360px) {
      padding: 10px 15px;
    }
  }
  &__cvvTitle {
    padding-right: 10px;
    font-size: 15px;
    font-weight: 500;
    color: #fff;
    margin-bottom: 5px;
  }
  &__cvvBand {
    height: 45px;
    background: #fff;
    margin-bottom: 30px;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
    color: #1a3b5d;
    font-size: 18px;
    border-radius: 4px;
    box-shadow: 0px 10px 20px -7px rgba(32, 56, 117, 0.35);

    @media screen and (max-width: 480px) {
      height: 40px;
      margin-bottom: 20px;
    }

    @media screen and (max-width: 360px) {
      margin-bottom: 15px;
    }
  }
}

.card-input {
  margin-bottom: 20px;
  &__label {
    font-size: 14px;
    margin-bottom: 5px;
    font-weight: 500;
    color: #1a3b5d;
    width: 100%;
    display: block;
    user-select: none;
  }
  &__input {
    width: 100%;
    height: 50px;
    border-radius: 5px;
    box-shadow: none;
    border: 1px solid #ced6e0;
    transition: all 0.3s ease-in-out;
    font-size: 18px;
    padding: 5px 15px;
    background: none;
    color: #1a3b5d;
    font-family: "Source Sans Pro", sans-serif;

    &:hover,
    &:focus {
      border-color: #3d9cff;
    }

    &:focus {
      box-shadow: 0px 10px 20px -13px rgba(32, 56, 117, 0.35);
    }
    &.-select {
      -webkit-appearance: none;
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAeCAYAAABuUU38AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUxJREFUeNrM1sEJwkAQBdCsngXPHsQO9O5FS7AAMVYgdqAd2IGCDWgFnryLFQiCZ8EGnJUNimiyM/tnk4HNEAg/8y6ZmMRVqz9eUJvRaSbvutCZ347bXVJy/ZnvTmdJ862Me+hAbZCTs6GHpyUi1tTSvPnqTpoWZPUa7W7ncT3vK4h4zVejy8QzM3WhVUO8ykI6jOxoGA4ig3BLHcNFSCGqGAkig2yqgpEiMsjSfY9LxYQg7L6r0X6wS29YJiYQYecemY+wHrXD1+bklGhpAhBDeu/JfIVGxaAQ9sb8CI+CQSJ+QmJg0Ii/EE2MBiIXooHRQhRCkBhNhBcEhLkwf05ZCG8ICCOpk0MULmvDSY2M8UawIRExLIQIEgHDRoghihgRIgiigBEjgiFATBACAgFgghEwSAAGgoBCBBgYAg5hYKAIFYgHBo6w9RRgAFfy160QuV8NAAAAAElFTkSuQmCC");
      background-size: 12px;
      background-position: 90% center;
      background-repeat: no-repeat;
      padding-right: 30px;
    }
  }
}

.slide-fade-up-enter-active {
  transition: all 0.25s ease-in-out;
  transition-delay: 0.1s;
  position: relative;
}
.slide-fade-up-leave-active {
  transition: all 0.25s ease-in-out;
  position: absolute;
}
.slide-fade-up-enter {
  opacity: 0;
  transform: translateY(15px);
  pointer-events: none;
}
.slide-fade-up-leave-to {
  opacity: 0;
  transform: translateY(-15px);
  pointer-events: none;
}

.slide-fade-right-enter-active {
  transition: all 0.25s ease-in-out;
  transition-delay: 0.1s;
  position: relative;
}
.slide-fade-right-leave-active {
  transition: all 0.25s ease-in-out;
  position: absolute;
}
.slide-fade-right-enter {
  opacity: 0;
  transform: translateX(10px) rotate(45deg);
  pointer-events: none;
}
.slide-fade-right-leave-to {
  opacity: 0;
  transform: translateX(-10px) rotate(45deg);
  pointer-events: none;
}
</style>